

const openFile = async (url: string): Promise<boolean> => {
  if (!url) {
    console.warn("fileService: URL vacía");
    throw new Error("URL vacía");
  }

  try {
    window.open(url, "_blank", "noopener,noreferrer");

    return true;
  } catch (error) {
    console.error("fileService: Error al abrir archivo", error);
    throw new Error("Error al abrir archivo");
  }
};

const fileSize = async (url: string): Promise<number> => {
  if (!url) {
    console.warn("fileService: URL vacía");
    throw new Error("URL vacía");
  }
  try {
    const response = await fetch(url, { method: "HEAD" });
    if (!response.ok) {
      throw new Error(`Error al obtener el tamaño del archivo: ${response.statusText}`);
    }
    const size = response.headers.get("content-length");
    if (!size) {
      throw new Error("No se pudo obtener el tamaño del archivo");
    }
    return size ? parseInt(size, 10) : 0;
  } catch (error) {
    console.error("fileService: Error al obtener el tamaño del archivo", error);
    throw new Error("Error al obtener el tamaño del archivo");
  }
};

const filesSize = async (urls: string[]): Promise<number> => {
  if (!urls || urls.length === 0) {
    console.warn("fileService: Lista de URLs vacía");
    throw new Error("Lista de URLs vacía");
  }
  try {
    const sizes = await Promise.all(urls.map(url => fileSize(url)));
    return sizes.reduce((acc, size) => acc + size, 0);
  } catch (error) {
    console.error("fileService: Error al obtener el tamaño de los archivos", error);
    throw new Error("Error al obtener el tamaño de los archivos");
  }
};

const fileService = { openFile, fileSize, filesSize };
export default fileService;